import axios from 'axios'
import router from '../router'
import store from '@/store';

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    'Content-Type': 'multipart/form-data',
  }
})

const getAuthInterceptor = async (config) => {
  var token = localStorage.getItem('token')
  if (token) {
    token = 'Bearer ' + token
  }
  else {
    return config
    // router.push('/')
  }
  config.headers['Authorization'] = token
  return config
}

httpClient.interceptors.request.use(getAuthInterceptor)

httpClient.interceptors.request.use(function (config) {
  store.commit('loading', true)
  // const isAuthenticate = config.url.match(/authenticate/g);
  // if (isAuthenticate) {
  //   config.withCredentials = false;
  // }
  // if (!isAuthenticate) {
  //   const token = window.localStorage.getItem('jwt');
  //   if (token) {
  //     config.headers.Authorization = `Bearer ${token}`;
  //   }
  // }
  return config;
});

httpClient.interceptors.response.use(
  function (response) {
    store.commit('loading', false)
    return response;
  },
  function (error) {
    store.commit('loading', false)
    if (!error.response) {
      // debugger
      // router.push('/')
    } else {
      // all the error responses
      switch (error.response.status) {
        case 401: { // authentication error, logout the user
          break
        }
        case 403: { // forbiden
          debugger
          break
        }
        case 404: { // forbiden
          debugger
          break
        }
        default:
      }
    }

    return Promise.reject(error)
  },
);


// interceptor to catch errors
const errorInterceptor = error => {
  if (!error.response) {
    // router.push('/')
  } else {
    // all the error responses
    switch (error.response.status) {
      case 401: { // authentication error, logout the user
        var backUrl = router.history._startLocation
        router.push(`/Login?state=login&backUrl=${encodeURIComponent(backUrl)}`)
        // setTimeout(() => {
        //   store.commit(
        //     "toast",
        //     {
        //       message: 'Please Login',
        //       color: "red lighten-2",
        //     }
        //   );
        // }, 3000);
        break
      }
      case 403: { // forbiden
        debugger
        break
      }
      case 404: { // forbiden
        debugger
        break
      }
      default:
    }
  }

  return Promise.reject(error)
}

// Interceptor for responses
const responseInterceptor = response => {
  return response
}

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor)

export default httpClient
